<template>
  <span class="cc" :class="[`cc--${status}`, { 'cc--compact': compact }]" :title="label.hint">
    <span class="cc__dot" aria-hidden="true" />
    <span v-if="!compact" class="cc__text">{{ label.text }}</span>
    <span v-else class="cc__sr">{{ label.text }}</span>
  </span>
</template>

<script setup lang="ts">
  import type { CodeConnectStatus } from './stories';

  const { status, compact = false } = defineProps<{
    status: CodeConnectStatus;
    compact?: boolean;
  }>();

  const LABELS: Record<CodeConnectStatus, { text: string; hint: string }> = {
    connected: { text: 'Code Connect', hint: 'Active figma.connect(...) mapping in <Component>.figma.ts' },
    disabled: { text: 'Mapping off', hint: '<Component>.figma.ts exists but figma.connect(...) is commented out' },
    missing: { text: 'No mapping', hint: 'No <Component>.figma.ts for this component' },
  };

  const label = computed(() => LABELS[status]);
</script>

<style lang="postcss" scoped>
  .cc {
    display: inline-flex;
    gap: 0.375rem;
    align-items: center;

    padding: 0.1875rem 0.5rem;
    border: 1px solid currentcolor;
    border-radius: 1rem;

    font-size: 0.6875rem;
    font-weight: 600;
    white-space: nowrap;
  }

  .cc--compact {
    padding: 0;
    border: 0;
  }

  .cc__dot {
    width: 0.4375rem;
    height: 0.4375rem;
    border-radius: 50%;
    background: currentcolor;
  }

  .cc__sr {
    position: absolute;

    overflow: hidden;

    width: 1px;
    height: 1px;

    clip-path: inset(50%);
  }

  .cc--connected {
    color: #1a7f37;
  }

  .cc--disabled {
    color: #9a6700;
  }

  .cc--missing {
    color: #929292;
  }
</style>
